import { PieChart, PieChartProps } from 'components/pie-chart';
import { copyFor } from 'config';
import { money } from 'utils/format';
import {
  PieWrapper,
  TextCallout,
  TextContent,
  TextHeader,
  TextTotal,
  pieColors,
} from '../pie-carousel.style';

type YourBillWithOutArcadiaProps = {
  options: PieChartProps['options'];
  total: number;
};

const getCopy = copyFor('billing.statement.pieCharts.yourBillWithoutArcadia');

export const YourBillWithoutArcadia: React.FC<YourBillWithOutArcadiaProps> = ({
  options,
  total,
}) => (
  <PieWrapper>
    <TextHeader>{getCopy('header')}</TextHeader>
    <PieChart
      data={{
        datasets: [
          {
            data: [100],
            backgroundColor: [pieColors.utility],
            borderWidth: [0],
          },
        ],
      }}
      height="200px"
      width="200px"
      options={options}
    />
    <TextTotal>{money(total)}</TextTotal>
    <TextCallout>{getCopy('callout')}</TextCallout>
    <TextContent>{getCopy('content')}</TextContent>
  </PieWrapper>
);
